(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ts-quantity-calculator"] && !Shopify.designMode) return;
  try {
    function tsCalculatorOrder(panel,quantity){
  const container=panel.closest('[id^="ProductInfo-"]');
  const form=container?.querySelector('form[action*="/cart/add"]');
  if(!form)return;
  if(!Number.isSafeInteger(quantity)||quantity<1){delete form.dataset.tsCalculatedQuantity;delete form.dataset.tsCalculatedVariant;return;}
  form.dataset.tsCalculatedQuantity=String(quantity);
  form.dataset.tsCalculatedVariant=form.querySelector('input[name="id"]')?.value||'';
  const input=container.querySelector('.quantity__input[name="quantity"]');
  if(input){input.value=quantity;input.dispatchEvent(new Event('change',{bubbles:true}));}
  if(!form.tsCalculatorCartBound){
    form.tsCalculatorCartBound=true;
    form.addEventListener('formdata',event=>{
      if(form.dataset.tsCalculatedQuantity && form.dataset.tsCalculatedVariant===form.querySelector('input[name="id"]')?.value){
        event.formData.set('quantity',form.dataset.tsCalculatedQuantity);
      }
    });
  }
}
function tsCalculate(panel){
  tsCalculatorOrder(panel,null);
  const number=(selector)=>Number(panel.querySelector(selector)?.value);
  const area=number('[data-area]'),rate=number('[data-rate]'),pack=number('[data-pack]'),factor=number('[data-unit]');
  const output=panel.querySelector('output');
  if(![area,rate,pack,factor].every(n=>Number.isFinite(n)&&n>0)){output.textContent=panel.dataset.start;return;}
  const required=area*rate*factor, count=required/pack;
  const maximum=Number(panel.dataset.maxRate);
  if(maximum>0&&rate*factor>maximum/10000+1e-12){output.textContent=panel.dataset.limit;return;}
  if(!Number.isFinite(count)||!Number.isFinite(required)){output.textContent=panel.dataset.start;return;}
  const format=n=>n.toLocaleString('en-GB',{maximumSignificantDigits:6});
  let message=panel.dataset.required+' '+format(required)+(panel.dataset.kind==='liquid'?' L':' kg')+'\n'+panel.dataset.packs+' '+Math.ceil(count-Number.EPSILON*Math.max(1,count));
  const water=number('[data-water-rate]');
  if(panel.dataset.kind==='liquid'&&water>0&&Number.isFinite(water)){message+='\n'+panel.dataset.water+' '+format(area*water/10000)+' L';}
  const lines=message.split('\n').map((line,index)=>{const node=document.createElement(index===1?'strong':'span');node.textContent=line;if(index===1)node.className='ts-result-quantity';return node;});
  output.replaceChildren(...lines);
  tsCalculatorOrder(panel,Math.ceil(count-Number.EPSILON*Math.max(1,count)));
}
if(typeof subscribe==='function')subscribe(PUB_SUB_EVENTS.variantChange,event=>{
  const container=document.getElementById('ProductInfo-'+event.data.sectionId);
  const panel=container?.querySelector('.ts-quantity-calculator');
  if(!panel)return;
  panel.dataset.variant=event.data.variant.title;
  const pattern=panel.dataset.kind==='liquid'?/(\d+(?:\.\d+)?)\s*(?:litres?|liters?|ltr|l)\b/i:/(\d+(?:\.\d+)?)\s*kg\b/i;
  const match=panel.dataset.variant.match(pattern)||panel.dataset.title.match(pattern);
  const grams=!match&&panel.dataset.kind==='solid' ? panel.dataset.variant.match(/(\d+(?:\.\d+)?)\s*g\b/i)||panel.dataset.title.match(/(\d+(?:\.\d+)?)\s*g\b/i) : null;
  panel.querySelector('[data-pack]').value=match?Number(match[1]):grams?Number(grams[1])/1000:'';
  tsCalculate(panel);
});
document.addEventListener('input',event=>{const panel=event.target.closest('.ts-quantity-calculator');if(panel)tsCalculate(panel);});
document.addEventListener('change',event=>{const panel=event.target.closest('.ts-quantity-calculator');if(panel)tsCalculate(panel);});
document.addEventListener('toggle',event=>{
  const panel=event.target;
  if(panel.matches?.('.ts-quantity-calculator')&&!panel.open){
    tsCalculatorOrder(panel,null);
    panel.querySelector('[data-area]').value='';
    panel.querySelector('output').textContent=panel.dataset.start;
    const quantity=panel.closest('[id^="ProductInfo-"]')?.querySelector('.quantity__input[name="quantity"]');
    if(quantity){quantity.value=quantity.min||1;quantity.dispatchEvent(new Event('change',{bubbles:true}));}
    return;
  }
  if(!panel.matches?.('.ts-quantity-calculator')||!panel.open||panel.dataset.initialised)return;
  panel.dataset.initialised='true';
  const pattern=panel.dataset.kind==='liquid'?/(\d+(?:\.\d+)?)\s*(?:litres?|liters?|ltr|l)\b/i:/(\d+(?:\.\d+)?)\s*kg\b/i;
  const match=panel.dataset.variant.match(pattern)||panel.dataset.title.match(pattern);
  if(match)panel.querySelector('[data-pack]').value=match[1];
  if(!match&&panel.dataset.kind==='solid'){
    const grams=panel.dataset.variant.match(/(\d+(?:\.\d+)?)\s*g\b/i)||panel.dataset.title.match(/(\d+(?:\.\d+)?)\s*g\b/i);
    if(grams)panel.querySelector('[data-pack]').value=Number(grams[1])/1000;
  }
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ts-turf-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
  const areaFrom = (shape, values) => {
    const keys = {rectangle:['length','width'],triangle:['base','height'],circle:['radius'],area:['area']}[shape];
    if (!keys || !keys.every(key=>Number.isFinite(values[key]) && values[key]>0)) return null;
    const area = shape==='rectangle' ? values.length*values.width : shape==='triangle' ? values.base*values.height/2 : shape==='circle' ? Math.PI*values.radius*values.radius : values.area;
    return Number.isFinite(area) && area>0 ? area : null;
  };
  const orderFor = (area, coverage, waste) => {
    if (!Number.isFinite(area) || area<=0 || !Number.isFinite(coverage) || coverage<=0) return null;
    const needed=area*(waste?1.05:1), ratio=needed/coverage, quantity=Math.ceil(ratio-Number.EPSILON*Math.max(1,ratio));
    return Number.isFinite(needed) && Number.isSafeInteger(quantity) && quantity>0 ? {needed,quantity,covered:quantity*coverage} : null;
  };
  const coverageFor = (title, variant) => {
    const pattern=/(\d+(?:\.\d+)?)\s*(?:m2|m²|sq\s*m)\b/i;
    const match=variant.match(pattern);
    if(match)return Number(match[1]);
    if(/bulk buy/i.test(title) && /^\d+(?:\.\d+)?$/.test(variant.trim()))return Number(variant);
    if(variant==='Default Title')return Number(title.match(pattern)?.[1])||null;
    return null;
  };
  const combinationFor = (needed, variants) => {
    const packs=variants.filter(v=>v.available && v.coverage>0).sort((a,b)=>b.coverage-a.coverage);
    if(!packs.length || !Number.isFinite(needed) || needed<=0)return null;
    const gcd=(a,b)=>b?gcd(b,a%b):a;
    const sizes=packs.map(v=>Math.round(v.coverage*1000));
    const unit=sizes.reduce(gcd);
    const steps=sizes.map(size=>size/unit);
    const target=Math.ceil(needed*1000/unit-1e-9);
    const limit=target+Math.min(...steps)-1;
    if(!Number.isSafeInteger(limit)||limit>1000000)return null;
    const counts=new Int32Array(limit+1);counts.fill(2147483647);counts[0]=0;
    const previous=new Int32Array(limit+1);previous.fill(-1);
    for(let total=1;total<=limit;total++){
      steps.forEach((size,index)=>{
        if(total>=size && counts[total-size]+1<counts[total]){
          counts[total]=counts[total-size]+1;previous[total]=index;
        }
      });
    }
    let total=target;
    while(total<=limit && previous[total]<0)total++;
    if(total>limit)return null;
    const quantities=packs.map(()=>0);
    for(let rest=total;rest>0;){const index=previous[rest];quantities[index]++;rest-=steps[index];}
    return {needed,covered:total*unit/1000,quantity:counts[total],items:packs.map((v,i)=>({...v,quantity:quantities[i]})).filter(v=>v.quantity)};
  };
  class TurfCalculator extends HTMLElement {
    connectedCallback(){
      if(this.initialised)return;
      this.initialised=true;
      this.data=JSON.parse(this.querySelector('[data-turf-data]').textContent);
      this.form=this.querySelector('form');this.output=this.querySelector('output');
      this.startMessage=this.output.textContent;
      this.container=this.closest('[id^="ProductInfo-"]');
      this.isBulkBuy=/bulk buy/i.test(this.data.title);
      if(this.isBulkBuy)this.form.elements.coverage.closest('label').hidden=true;
      this.sync();
      this.form.addEventListener('submit',event=>{event.preventDefault();this.calculate();});
      this.form.addEventListener('input',()=>{this.shapes();this.calculate();});
      this.form.addEventListener('change',()=>{this.shapes();this.calculate();});
      this.onVariant=event=>{if(event.target.name==='id'){this.sync();this.calculate();}};
      this.container?.addEventListener('change',this.onVariant);
      if(this.isBulkBuy && typeof subscribe==='function'){
        this.variantUnsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
          if(event.data.variant.id===this.recommendedVariant?.id)queueMicrotask(()=>this.updateOrderQuantity());
        });
      }
      this.cartForm=this.container?.querySelector('form[action*="/cart/add"]');
      this.onCartFormData=event=>{
        if(this.isBulkBuy && this.orderItems?.length){
          event.formData.delete('id');event.formData.delete('quantity');
          this.orderItems.forEach((item,index)=>{
            event.formData.set('items['+index+'][id]',String(item.id));
            event.formData.set('items['+index+'][quantity]',String(item.quantity));
          });
        }else if(this.orderQuantity && this.variantId){
          event.formData.set('id',String(this.recommendedVariant?.id||this.variantId));
          event.formData.set('quantity',String(this.orderQuantity));
        }
      };
      this.cartForm?.addEventListener('formdata',this.onCartFormData);
      this.onCalculatorToggle=()=>{
        if(this.querySelector('details').open)return;
        this.orderQuantity=null;this.orderItems=null;
        ['length','width','base','height','radius','area'].forEach(name=>this.form.elements.namedItem(name).value='');
        this.output.textContent=this.startMessage;
        const quantity=this.container?.querySelector('.quantity__input[name="quantity"]');
        if(quantity){quantity.value=quantity.min||1;quantity.dispatchEvent(new Event('change',{bubbles:true}));}
      };
      this.querySelector('details').addEventListener('toggle',this.onCalculatorToggle);

    }
    disconnectedCallback(){this.container?.removeEventListener('change',this.onVariant);this.variantUnsubscribe?.();this.cartForm?.removeEventListener('formdata',this.onCartFormData);this.querySelector('details')?.removeEventListener('toggle',this.onCalculatorToggle);this.initialised=false;}
    sync(){
      if(!this.data.variants.length)return;
      const id=Number(this.container?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value)||this.data.selected;
      const variant=this.isBulkBuy ? this.data.variants.filter(v=>v.available).map(v=>({...v,coverage:coverageFor(this.data.title,v.title)})).filter(v=>v.coverage>0).sort((a,b)=>b.coverage-a.coverage)[0] : this.data.variants.find(v=>v.id===id);
      this.variantId=variant?.id;
      this.recommendedVariant=this.isBulkBuy ? variant : null;
      this.form.elements.coverage.value=variant ? coverageFor(this.data.title,variant.title)||'' : '';
    }
    selectBulkDeal(){
      const variant=this.recommendedVariant;
      if(!variant || !this.container)return;
      const picker=this.container.querySelector('variant-selects');
      const id=Number(this.container.querySelector('form[action*="/cart/add"] input[name="id"]')?.value);
      if(id===variant.id){this.updateOrderQuantity();return;}
      const radio=Array.from(picker?.querySelectorAll('input[type="radio"]')||[]).find(input=>input.value===variant.title);
      const select=Array.from(picker?.querySelectorAll('select')||[]).find(input=>Array.from(input.options).some(option=>option.value===variant.title));
      const control=radio||select;
      if(!control)return;
      if(radio)radio.checked=true;else select.value=variant.title;
      control.dispatchEvent(new Event('change',{bubbles:true}));
      this.updateOrderQuantity();
    }
    updateOrderQuantity(){
      if(!this.orderQuantity || !this.container)return;
      const input=this.container.querySelector('.quantity__input[name="quantity"]');
      if(!input)return;
      input.value=this.orderItems?.[0]?.quantity||this.orderQuantity;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }
    shapes(){const shape=this.form.elements.shape.value;this.querySelectorAll('[data-shape]').forEach(node=>{node.hidden=node.dataset.shape!==shape;node.querySelectorAll('input').forEach(input=>input.disabled=node.hidden);});}
    calculate(){
      const values={};['length','width','base','height','radius','area'].forEach(key=>values[key]=Number(this.form.elements.namedItem(key).value));
      const area=areaFrom(this.form.elements.shape.value,values);
      const result=this.isBulkBuy ? combinationFor(area*(this.form.elements.waste.checked?1.05:1),this.data.variants.map(v=>({...v,coverage:coverageFor(this.data.title,v.title)}))) : orderFor(area,Number(this.form.elements.coverage.value),this.form.elements.waste.checked);
      if(!result){this.orderQuantity=null;this.orderItems=null;this.output.textContent=this.dataset.invalid;return;}
      const format=value=>value.toLocaleString('en-GB',{maximumFractionDigits:2});
      const areaLine=document.createElement('span');areaLine.textContent=this.dataset.areaLabel+' '+format(result.needed)+' m²';
      const quantityLine=document.createElement('strong');quantityLine.className='ts-turf-result-quantity';quantityLine.textContent=this.dataset.quantityLabel+' '+(result.items ? result.items.map(item=>item.quantity+' × '+item.title).join(' + ') : result.quantity);
      const coverageLine=document.createElement('span');coverageLine.textContent=this.dataset.coveredLabel+' '+format(result.covered)+' m²';
      this.output.replaceChildren(areaLine,quantityLine,coverageLine);
      if(this.container){
        const addButton=document.createElement('button');
        addButton.type='button';addButton.className='ts-turf-add-calculated';
        addButton.textContent=this.dataset.addLabel;
        addButton.addEventListener('click',()=>{
          const cartForm=this.container.querySelector('product-form form[action*="/cart/add"]');
          const submitButton=cartForm?.querySelector('[type="submit"]');
          if(!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled')==='true')return;
          submitButton.click();
        });
        this.output.append(addButton);
      }
      const quantityInput=this.container?.querySelector('.quantity__input[name="quantity"]');
      const minimum=Number(quantityInput?.dataset.turfMinimum)||1;
      const step=Number(quantityInput?.step)||1;
      if(!this.isBulkBuy && minimum>1){result.quantity=Math.max(minimum,minimum+Math.ceil((result.quantity-minimum)/step)*step);result.covered=result.quantity*Number(this.form.elements.coverage.value);quantityLine.textContent=this.dataset.quantityLabel+' '+result.quantity;coverageLine.textContent=this.dataset.coveredLabel+' '+format(result.covered)+' m²';}
      this.orderQuantity=result.quantity;
      this.orderItems=result.items||null;
      if(this.isBulkBuy){this.recommendedVariant=result.items[0];this.selectBulkDeal();}else this.updateOrderQuantity();
    }
  }
  if(!customElements.get('ts-turf-calculator'))customElements.define('ts-turf-calculator',TurfCalculator);
})();
  } catch(e) { console.error(e); }
})();

})();
